<template>
  <form class="shift">
    <h4>{{mode === 'addShift' ? $t('addingShift') : $t('editingShift')}}</h4>
    <v-select outlined dense :items="shiftName" :label="$t('shiftName')" v-model="shiftObj.name"/>
    <div style="display: flex; flex-direction: row; gap: 8px">
      <div class="time">
        <v-menu ref="menuFrom" v-model="menuFrom" :close-on-content-click="false" :nudge-right="40"
                :return-value.sync="shiftObj.startTime" transition="scale-transition" offset-y
                max-width="290px" min-width="290px">
          <template v-slot:activator="{ on, attrs }">
            <v-text-field v-model="shiftObj.startTime" label="Начало смены" outlined dense
                          prepend-inner-icon="mdi-clock-time-four-outline" readonly v-bind="attrs" v-on="on"/>
          </template>
          <v-time-picker v-if="menuFrom" v-model="shiftObj.startTime" full-width format="24hr"
                         @click:minute="$refs.menuFrom.save(shiftObj.startTime)"/>
        </v-menu>
      </div>
      <div class="time">
        <v-menu ref="menuTo" v-model="menuTo" :close-on-content-click="false" :nudge-right="40"
                :return-value.sync="shiftObj.endTime" transition="scale-transition" offset-y
                max-width="290px" min-width="290px">
          <template v-slot:activator="{ on, attrs }">
            <v-text-field v-model="shiftObj.endTime" label="Окончание смены" outlined dense
                          prepend-inner-icon="mdi-clock-time-four-outline" readonly v-bind="attrs" v-on="on"/>
          </template>
          <v-time-picker v-if="menuTo" v-model="shiftObj.endTime" full-width format="24hr"
                         @click:minute="$refs.menuTo.save(shiftObj.endTime)"/>
        </v-menu>
      </div>
    </div>
    <div class="btn-actions" v-if="mode === 'addShift'">
      <v-btn color="primary" @click="closeModal">{{ $t('cancel') }}</v-btn>
      <v-btn color="green" @click="createShift" :disabled="!shiftObj.name">{{ $t('next') }}</v-btn>
    </div>
  </form>
</template>

<script>
import Shift from "@/views/school-admin/Shift.vue";
import Timeselector from 'vue-timeselector'

export default {
  components: {Shift, Timeselector},
  props: {
    shiftObj: Object,
    mode: String
  },
  data () {
    return {
      required: [v => !!v || this.$t('Обязательное поле')],
      menuFrom: false,
      menuTo: false,
      shiftName: ['1-смена', '2-смена', '3-смена'],
    }
  },
  methods: {
    createShift () {
      this.$emit('createShift');
    },
    closeModal () {
      this.$emit('closeModal');
    }
  },
}
</script>

<style scoped lang="scss">
.shift{
  display: flex;
  flex-direction: column;
}

.label {
  color: #9E9E9E;
  font-size: 12px;
  margin-left: 3px;
}
.el {
  border: 1px solid #9E9E9E;
  border-radius: 5px;
  padding: 4px 8px;
}
.time{
  width: 50%;
}
</style>
